import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Link} from 'react-router';
import classNames from 'classnames';

import Maps from './Maps'

import './Navigation.scss';

import {openMenu, closeStory, muteAudio, startDriving, pauseDriving} from '../../state/actions/timeline';

import Icons from '../Shared/Icons';

class Navigation extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    render() {
        const classNameNavigation = classNames({
            "Navigation": true,
            "Navigation--open":  this.props.isMenuOpen,
            "Navigation--storyOpen":  this.props.isStoryOpen
        });

        const classNameBurger = classNames({
            "Navigation__burger": true,
            "Navigation__burger--x":  this.props.isMenuOpen || this.props.isStoryOpen,
            "Navigation__burger--storyOpen":  this.props.isStoryOpen
        });

        const classNameToolbar = classNames({
            "Navigation__toolbar": true,
            "Navigation__toolbar--storyOpen":  this.props.isStoryOpen
        });

        const classNameOverlay = classNames({
            "Navigation__overlay": true,
            "Navigation__overlay--storyStarted":  this.props.tripStarted
        });

        const colorIcons = this.props.isStoryOpen;

        const audioToggleIcon = this.buildAudioToggle();
        const fullScreenIcon = this.buildFullScreenToggle();

        const logo = this.props.tripStarted || this.props.isMenuOpen ? <div className="Navigation__logo" onClick={this.showMenu.bind(this)}><Icons type="logo" flipColor={colorIcons} /></div> : null;

        const maps = this.props.isMenuOpen ? <Maps /> : null;

        const linkAbout = this.props.language ? `/${this.props.language}/pagina/about` : "/pagina/about";

        return (
            <div className={classNameNavigation}>

                <div className={classNameToolbar}>
                    {fullScreenIcon}
                    {audioToggleIcon}

                    {logo}

                    <div className={classNameBurger} onClick={this.showMenu.bind(this)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>


                <div className="Navigation__background">
                </div>

                <div className={classNameOverlay}>

                    {maps}

                    <div className="Navigation__footer">

                        <div className="Navigation__footer__about">
                            <Link className="Navigation__footer__about__link" to={linkAbout}>About</Link>
                        </div>

                        <div className="Navigation__footer__language">
                            <Link to="/nl" className={classNames({"active": this.props.language === "nl"})}>NL</Link>
                            /
                            <Link to="/" className={classNames({"active": this.props.language !== "nl"})}>ENG</Link>
                        </div>

                    </div>

                </div>
            </div>
        );
    }

    buildAudioToggle () {
        const classNameAudioToggle= classNames({
            "Navigation__audioToggle": true,
            "Navigation__audioToggle--active":  this.props.audioMuted
        });

        return this.props.isStoryOpen ? null: <div className={classNameAudioToggle} onClick={() => this.props.muteAudio(!this.props.audioMuted)}><Icons type="audio" flipColor={this.props.audioMuted}  /></div>;
    }

    buildFullScreenToggle () {
        return this.props.tripStarted && !this.props.isStoryOpen && window.chrome ? <div className="Navigation__fullScreenToggle" onClick={() => this.toggleFullScreen()}><Icons type="fullscreen" flipColor={this.props.audioMuted}  /></div> : null;
    }

    toggleFullScreen () {
        if (window.chrome && !document.webkitIsFullScreen) {
            document.body.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else {
            document.webkitCancelFullScreen();
        }
    }

    showMenu () {
        if (this.props.isStoryOpen) {

            // Close detail
            this.context.router.push(`/${this.props.language}`);
            this.props.startDriving();

        } else {

            // Open or close menu
            if (this.props.isMenuOpen) {
                this.props.openMenu(false);
                if(this.props.tripStarted) this.props.startDriving();
            } else {
                this.props.openMenu(true);
                this.props.pauseDriving();
            }

        }
    }
}

function mapStateToProps({timeline}) {
    return {
        isMenuOpen: timeline.isMenuOpen,
        isStoryOpen: timeline.storyIsOpen,
        tripStarted: timeline.tripStarted,
        audioMuted: timeline.audioMuted,
        language: timeline.language
    }
}

export default connect(mapStateToProps, {openMenu, closeStory, muteAudio, startDriving, pauseDriving})(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js